<template>
    <div class="base-list">
        <TransitionGroup
            tag="ul"
            name="list"
            class="base-list__content list--clean"
        >
            <slot />
        </TransitionGroup>

        <div class="base-list__bottom">
            <slot name="after" />
        </div>
    </div>
</template>

<style lang="less">
.base-list {
    ul.base-list__content {
        display: grid;
    }

    ul.base-list__content > li {
        padding-left: .25rem;
    }

    @media @q-sm-min {
        ul.base-list__content > li {
            padding-left: .75rem;
        }
    }
}

.base-list--no-padding {
    ul.base-list__content > li {
        padding-left: 0;
    }

    @media @q-sm-min {
        ul.base-list__content > li {
            padding-left: 0;
        }
    }
}

.base-list .base-list__content {
    li + li {
        margin-top: 1rem;
    }
}


.list-enter-active,
.list-leave-active {
    transition: opacity var(--transition-timing-fast) 0ms var(--transition-timingFunction-in-out),
        transform var(--transition-fast);
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateY(-1rem);
}
</style>
